import React from 'react';

function Input({ placeholder, type, nameInput }) {
  return (
    <input
      type={type}
      required
      outline-none='true'
      className={`bg-amber border border-amber text-gray200 placeholder-textColor focus:placeholder:text-gray700 text-lg rounded-lg focus:ring-gray-500 focus:border-gray500 focus:outline-none w-10/12 p-3 mx-2 my-1 focus:bg-[#eee] focus:text-gray500 focus:font-bold transition-all`}
      placeholder={placeholder}
      name={nameInput}
    />
  );
}

export default Input;
